const initials = "usersList/";

export const UPDATE_USERS_LIST = `${initials}UPDATE_USERS_LIST`;